import React from 'react';
import styles from './styles.module.scss';

import cn from 'classnames';

const ReasonTypeWrap = ({ reason = '' }) => {
  const map_reason = () => {
    if (reason === 'limit_shipment_diff') {
      return 'Проставление расхождений';
    }
    return reason;
  };
  return (
    <div
      className={cn(
        styles.status,
        reason === 'Отзыв' && styles.type_1,
        reason === 'Экспрессы' && styles.type_3,

        reason === 'Обнаружен брак' && styles.type_2,
        reason === 'Пропик не вовремя' && styles.type_5,
        reason === 'Упаковка не вовремя' && styles.type_6,
        reason === 'Другое' && styles.type_3,
        reason === 'Удержание' && styles.type_3,
        reason === 'Неотгруз' && styles.type_4,
        reason === 'Несогласованное расхождение' && styles.type_2,
        reason === 'Неотгруз' && styles.type_2,
        reason === 'Много отмен' && styles.type_2,
        reason === 'Косяк склада' && styles.type_4,
        reason === 'Неотгруз докупа' && styles.type_2,
        reason === 'Проверка излишек' && styles.type_4,
        reason === 'Проверка склада' && styles.type_1,
        reason === 'Проверка резервов' && styles.type_2,
        reason === 'limit_shipment_diff' && styles.type_2,
      )}
    >
      {map_reason(reason)}
    </div>
  );
};

export default ReasonTypeWrap;
